import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`Route has 1L 1M extra for random battles, 2L 0M if HP Thief Hrodvitnir fight.`}</p>
    </blockquote>
    <SEO title="Octopath Traveler Ophilia 3 Character" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Guide Summon Winds`}<br parentName="p"></br>{`
`}{`Purchase Quartz Rod`}</p>
    <h4 {...{
      "id": "guardian-1924hp"
    }}>{`Guardian 1924HP`}</h4>
    <p>{`Summon, Holy Light x4 when Broken`}</p>
    <p>{`Head to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Light S`}</strong>{`, `}<strong parentName="p">{`Light M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Quartz Rod`}</strong>{` & equip to Cyrus`}</p>
    <p>{`Optionally pick `}<strong parentName="p">{`Light S`}</strong>{` in Study`}</p>
    <h4 {...{
      "id": "russell-3097hphp"
    }}>{`Russell 3097HP/?HP`}</h4>
    <p>{`Summon for Wind and Break Russell`}<br parentName="p"></br>{`
`}{`Use Fire Ball T1 and T2 for Break Icicle`}<br parentName="p"></br>{`
`}{`Use 1 Small Soulstone + Max Icy Wind for kill Icicle (need 1 winds)`}<br parentName="p"></br>{`
`}{`When Russell are broken use BPx4 Holy Light and BPx4 Fire Ball/Small Stone`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Luminiscence`}</li>
        <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      </ul>
    </Menu>
    <p>{`Go to Whistlewood, kill stuff till Cyrus has enough JP for EM`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job-1"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`. Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Pick `}<strong parentName="p">{`Light M`}</strong>{`, `}<strong parentName="p">{`Light L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`. Go to `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Light L + Light M`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Shrine of the Rune Blade`}</strong>{`. Tag `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$50000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`. Head to `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p><strong parentName="p">{`North Stonegard Pass`}</strong>{`: Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Moonstruck Coast`}</strong>{`: S&Q, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`West Goldshore Coast`}</strong>{`: Scrutinize `}<strong parentName="p">{`A Safe Route`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Grandport Coast`}</strong>{`: Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <p>{`Run to `}<strong parentName="p">{`Saintsbridge`}</strong>{`, start Chapter 2.`}</p>
    <h3 {...{
      "id": "chapter-2-start"
    }}>{`Chapter 2 Start`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Shadow M & L`}</strong>{`. After cutscene by middle TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Scrutinize `}<strong parentName="p">{`More Items in Shop (30%)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Wind M & L`}</strong>{`.`}</p>
    <p>{`S&Q outside Murkwood, kill if you got the encounter before.`}<br parentName="p"></br>{`
`}{`In Murkwood kill encounter with L Stone`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Reflective Veil, `}<strong parentName="li">{`Warrior`}</strong>{`, Spearhead + Thousand Spears (also EI if 360JP)`}</li>
        <li parentName="ul">{`Cyrus: Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Tressa: Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Cover`}</li>
        <li parentName="ul">{`Cyrus & Tressa: Endless Items`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir-34969hp-sword-spear-ice-lightning-light"
    }}>{`Hrodvitnir 34969HP (Sword, Spear, Ice, Lightning, Light)`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      <li parentName="ul">{`Tressa: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: (Sword / Spear) x3 or Thousand Spears`}</li>
      <li parentName="ul">{`Cyrus: L Stone`}</li>
      <li parentName="ul">{`Tressa: L Stone`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: Collect x4`}</li>
      <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      <li parentName="ul">{`Ophilia: L Stone`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "shop"
      }}>{`Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 6 Empowering Bracelet`}</li>
        <li parentName="ul">{`Buy 1 Charm Robe, attach to Cyrus`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Complete `}<strong parentName="p">{`A Safe Route`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong>{`. Scrutinize `}<strong parentName="p">{`Wind L`}</strong>{`, pick `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`2 L Stone`}</strong>{`. Purchase `}<strong parentName="p">{`2 Pom L`}</strong>{`, `}<strong parentName="p">{`1 HGB`}</strong>{`, `}<strong parentName="p">{`1 Pom M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Pick `}<strong parentName="p">{`$25000`}</strong>{`, `}<strong parentName="p">{`Dazzling Artwork`}</strong>{`.`}</p>
    <p>{`Scrutinize & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Pom M`}</strong>{` and `}<strong parentName="p">{`Grape M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: 2 Bracelet`}</li>
        <li parentName="ul">{`Cyrus: 2 Bracelet`}</li>
        <li parentName="ul">{`Tressa: 2 Bracelet`}</li>
      </ul>
      <p>{`Heal with heal wounds`}</p>
    </Menu>
    <h3 {...{
      "id": "path-to-the-seaside-grotto"
    }}>{`Path to the Seaside Grotto`}</h3>
    <ul>
      <li parentName="ul">{`Azure Urchin: (1) 5611HP `}{`[Spear, Thunder, Light]`}</li>
      <li parentName="ul">{`Dark Curator: (3) 4790HP `}{`[Spear, Bow, Staff, Light]`}</li>
      <li parentName="ul">{`Flame Curator: (2) 4557HP `}{`[Spear, Bow, Staff, Ice]`}</li>
      <li parentName="ul">{`Scythe Crab: (3) 2484HP `}{`[Dagger, Axe, Wind]`}</li>
      <li parentName="ul">{`Mossy Tortoise: (4) 3808HP `}{`[Sword, Wind]`}</li>
    </ul>
    <h4 {...{
      "id": "battles"
    }}>{`Battles`}</h4>
    <ul>
      <li parentName="ul">{`1 Dark Curator 2 Flame Curator: go for Flurry, Blizzard.`}</li>
      <li parentName="ul">{`2 Dark Curator 1 Flame Curator: need a Flurry, can Blizzard to stall a bit. `}</li>
      <li parentName="ul">{`1 Azure Urchin 3 Scythe Crab: 3xHH800$ breaks crabs, Holy Light the Urchin. `}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Mossy Tortoise: 4xHH150, Holy Light the Urchin`}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Flame Curator 1 Scythe Crab: `}<ul parentName="li">
          <li parentName="ul">{`Ophilia Holy Light Azure Urchin, Cyrus Blizzard, Tressa Defend + 3HH800$`}</li>
          <li parentName="ul">{`If Therion before Tressa, can try to Dagger Scythe Crab to save a turn`}</li>
        </ul></li>
    </ul>
    <p>{`S&Q inside Seaside Grotto.`}</p>
    <h4 {...{
      "id": "mystery-man--shady-figure-2817232197hp"
    }}>{`Mystery Man & Shady Figure (28172/32197HP)`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom M Cyrus`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Tressa: HHB / Spear if feeling risky`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: HHB x4`}</li>
      <li parentName="ul">{`Ophilia: Pom M Cyrus`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
      <li parentName="ul">{`Ophilia: L Stone`}</li>
      <li parentName="ul">{`Cyrus: HHV x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`. Guide `}<strong parentName="p">{`Worry Wart`}</strong>{` (Inhibit Defenses).`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to `}<strong parentName="p">{`Whispermill`}</strong>{`.`}</p>
    <p>{`Break Plains Drake battle with Thousand Spears and Cyrus/Tressa Spear Attacks. Then Flee.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Everything till $89000`}</li>
      </ul>
    </Menu>
    <p>{`S&Q in second screen. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <p>{`Break with HHM x4, kill with 1 L Stone + 2 M Stone`}</p>
    <h4 {...{
      "id": "mattias-97686hp"
    }}>{`Mattias 97686HP`}</h4>
    <p>{`Need roughly 2 Vets with def down, 2 without, and 3 L Stone`}</p>
    <p>{`2 Cutscene then GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      